import { useDocumentTitle } from '@shared/hooks';

const NoPage = () => {
  useDocumentTitle('Confideck');

  return <p className="p-4 text-lg">Page not found!</p>;
};

export default NoPage;
